import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  sendMessage,
  sendPaymentReminder,
  sendPunjabiMessage,
} from "../../utils/api";
import Table from "../Table";

const CustomerMessage = ({ customerData, id }) => {
  const [checked, setChecked] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [sendingPunjabiMessage, setSendingPunjabiMessage] = useState(false);
  const [sendingPaymentReminder, setSendingPaymentReminder] = useState(false);

  // ✅ Auto-check all rows by default when customerData changes
  useEffect(() => {
    if (customerData?.length > 0) {
      const defaultChecked = customerData.map((item) => ({
        id: item._id,
        amount: item.balance,
      }));
      setChecked(defaultChecked);
    }
  }, [customerData]);

  const handleSendPaymentReminder = async () => {
    if (sendingPaymentReminder) return;
    if (checked.length < 1)
      return toast.error("Please select at least one user");
    setSendingPaymentReminder(true);
    const [success] = await sendPaymentReminder({ data: checked });
    if (success) {
      toast.success("Payment reminder sent successfully");
    }
    setSendingPaymentReminder(false);
  };

  const handleSend = async () => {
    if (isLoading) return;
    if (checked.length < 1)
      return toast.error("Please select at least one user");
    setIsLoading(true);
    const [success] = await sendMessage({ data: checked });
    if (success) {
      toast.success("Message sent successfully");
    }
    setIsLoading(false);
  };

  const handlePunjabiMessage = async () => {
    if (sendingPunjabiMessage) return;
    if (checked.length < 1)
      return toast.error("Please select at least one user");
    setSendingPunjabiMessage(true);
    const [success] = await sendPunjabiMessage({ data: checked });
    if (success) {
      toast.success("Punjabi message sent successfully");
    }
    setSendingPunjabiMessage(false);
  };

  return (
    <div className="flex flex-col md:w-full">
      {checked.length > 0 && (
        <div className="flex justify-between items-center">
          <Button onClick={handleSend} variant="contained" color="primary">
            {isLoading
              ? "Sending..."
              : `Send Message to ${checked.length} ${
                  checked.length > 1 ? "users" : "user"
                }`}
          </Button>
          <Button
            onClick={handlePunjabiMessage}
            variant="contained"
            color="primary"
          >
            {sendingPunjabiMessage
              ? "Sending..."
              : `Send Punjabi Message to ${checked.length} ${
                  checked.length > 1 ? "users" : "user"
                }`}
          </Button>

          <Button
            onClick={handleSendPaymentReminder}
            variant="contained"
            color="primary"
          >
            {sendingPaymentReminder
              ? "Sending..."
              : `Payment Reminder to ${checked.length} ${
                  checked.length > 1 ? "users" : "user"
                }`}
          </Button>
        </div>
      )}

      <Table
        columns={[
          {
            title: "Name",
            dataIndex: "name",
            render: (record) => (
              <p>
                {record?.name}{" "}
                {record?.clients?.length > 0 && (
                  <>
                    ({record?.clients?.map((item) => item.userName)?.join(",")})
                  </>
                )}
              </p>
            ),
          },
          {
            title: "Mobile no",
            dataIndex: "phoneNumber",
          },
          {
            title: "Agency",
            dataIndex: "agency",
            render: (record) => <div>{record?.agency || "-"}</div>,
          },
          {
            title: "FSSAI no",
            dataIndex: "fssai",
            render: (record) => <div>{record?.fssai || "-"}</div>,
          },
          {
            title: "Balance",
            dataIndex: "balance",
            render: (record) => <div>{record?.balance?.toFixed(2)}</div>,
          },
          {
            title: "Tag",
            dataIndex: "tag",
            td: (record) => (
              <td
                className={`border px-2 py-1 border-black ${
                  record?.wagon === 0
                    ? "bg-yellow-400"
                    : record?.tag < 0
                    ? "bg-red-500"
                    : "bg-green-500"
                }`}
              >
                <a
                  href={`/admin/customer?id=${record?._id}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {record?.tag.toFixed(0)}
                </a>
              </td>
            ),
          },
          {
            title: "Msg",
            render: (item) => (
              <input
                type="checkbox"
                checked={!!checked.find((i) => i.id === item._id)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setChecked((prev) => [
                      ...prev,
                      { id: item._id, amount: item.balance },
                    ]);
                  } else {
                    setChecked((prev) => prev.filter((i) => i.id !== item._id));
                  }
                }}
              />
            ),
          },
          {
            title: "PDF",
            link: `/admin/pdf/customer/${id}`,
          },
        ]}
        data={customerData}
      />
    </div>
  );
};

export default CustomerMessage;
